/**
 * National quitlines by ISO 3166 alpha-2 country. The Philippines comes first and is the fallback
 * (Tahi's first users). Add a country by adding a row; the UI reads only this list.
 * Ivan re-confirms the PH number before each release (Task 27).
 */
export interface Quitline {
  country: string;
  countryName: string;
  name: string;
  /** As shown. */
  phone: string;
  /** For the tel: link. */
  tel: string;
  url: string | null;
}

export const QUITLINES: readonly Quitline[] = [
  {
    country: 'PH',
    countryName: 'Philippines',
    name: 'DOH Quitline',
    phone: '1558',
    tel: '1558',
    url: null,
  },
  {
    country: 'US',
    countryName: 'United States',
    name: '1-800-QUIT-NOW',
    phone: '1-800-784-8669',
    tel: '+18007848669',
    url: 'https://smokefree.gov',
  },
  {
    country: 'GB',
    countryName: 'United Kingdom',
    name: 'NHS Smokefree helpline',
    phone: '0300 123 1044',
    tel: '+443001231044',
    url: 'https://www.nhs.uk/better-health/quit-smoking/',
  },
  {
    country: 'AU',
    countryName: 'Australia',
    name: 'Quitline',
    phone: '13 7848',
    tel: '137848',
    url: 'https://www.quit.org.au',
  },
];

export const DEFAULT_QUITLINE_COUNTRY = 'PH';

/** 'en-PH' -> 'PH'. Null when the locale has no region or can't be parsed. */
export function regionOf(locale: string | null | undefined): string | null {
  if (!locale) return null;
  try {
    return new Intl.Locale(locale).region ?? null;
  } catch {
    return null;
  }
}

export function quitlineFor(country: string | null | undefined): Quitline {
  const c = country?.toUpperCase();
  return (
    QUITLINES.find((q) => q.country === c) ??
    QUITLINES.find((q) => q.country === DEFAULT_QUITLINE_COUNTRY) ??
    (QUITLINES[0] as Quitline)
  );
}
